<template>
    <div></div>
</template>
<script>

export default {
    name: "modal",
    props: {
        message: String,
        toggle: Boolean
    },
    watch: {
        toggle: function () {
            this.showDialog();
        }
    },
    methods: {
      showDialog() {
        this.$bvModal.msgBoxConfirm(this.message, {
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'primary',
          cancelVariant: 'outline-primary',
          okTitle: 'Ja',
          cancelTitle: 'Nein',
          bodyClass: 'modal-body',
          footerClass: 'modal-footer',
          hideHeaderClose: false,
          centered: false
        })
          .then(value => {
            if(value) {
                this.$emit('modal_confirm');
            } else {
                this.$emit('modal_cancel');
            }
          })
          .catch(err => {
            
          })
      },
    }
}
</script>
<style lang="scss">
    .modal-body {
        font-size: $rv-font-size-base;
    }
    .modal-footer {
        button:nth-child(1) {
            border-color: $rv-primary;
            color: $rv-primary;
        }
        button:nth-child(2) {
            background-color: $rv-primary;
            border-color: $rv-primary;
        }
    }
</style>